import * as React from 'react';
import AutosizeInput from 'react-input-autosize';
import styled from 'styled-components';
import cl from 'classnames';
import { colorsV2 } from '../../colors-v2';

const Input = styled(AutosizeInput)`
  input {
    height: 20px;
    background-color: transparent;
    border: none;
    outline: none;
    padding: 0;

    font-weight: 500;
    font-size: 14px;
    line-height: 20px;

    &:disabled {
      opacity: 1;
    }
  }

  &.disabled {
    input {
      cursor: not-allowed;
      color: ${colorsV2.black40};
    }
  }
`;

interface InputContentAutoSizeProps {
  className?: string;
  defaultValue?: string;
  value?: string | number;
  placeholder?: string;
  onChange?: (changedValue: string) => void;
  onPaste?: (event: any) => void;
  readonly?: boolean;
  disabled?: boolean;
}

export const InputContentAutoSize = (props: InputContentAutoSizeProps) => {
  const {
    className,
    defaultValue,
    value: inputValue,
    placeholder,
    onChange,
    onPaste,
    readonly = false,
    disabled = false,
  } = props;
  const [value, setValue] = React.useState(defaultValue || '');
  const hasInputValue = inputValue !== undefined;

  return (
    <Input
      className={cl('input-content-auto-size', className, { readonly, disabled })}
      value={hasInputValue ? inputValue : value}
      placeholder={placeholder}
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        setValue(e.target.value);
        onChange?.(e.target.value);
      }}
      onPaste={onPaste}
      disabled={readonly || disabled}
    />
  );
};
